import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import appInsightsPlugin from './plugin/app-insights/app-insights-plugin'
import { initalizeAzureADAsync } from '@/features/auth/azure-ad'
import appProvidePlugin from '@/plugin/app-provide/app-provide-plugin'
import { focusableDirective } from './directives'
import moment from 'moment/min/moment-with-locales'
import 'moment/locale/fr'
import { createEventBus } from './plugin/event-bus/createEventBus'
import type { AppBusEvents } from '@/features/application/app-events'
import { SnackbarService } from 'vue3-snackbar'
import { RegistrationDSComponents } from '@/plugin/registration'

moment.locale('fr')

initalizeAzureADAsync().then(() => {
  const app = createApp(App)
  app.use(createEventBus<AppBusEvents>())
  app.use(SnackbarService)
  app.use(RegistrationDSComponents)
  app.use(createPinia())
  app.use(appProvidePlugin)
  app.use(appInsightsPlugin, { router })
  app.use(router)
  app.directive('focusable', focusableDirective)
  app.mount('#app')
})
